import {useSyncEventUpdateEffect} from '@containers/hooks'
import {globals} from '@extensions/globals-base'
import React from 'react'
import {Lang} from 'yougile-lang'
import {DataObjectId} from 'yougile-model'
import {InWorkflow} from './in-workflow'
import {NotInWorkflow} from './not-in-workflow'
import {getTaskWorkflowState, getWorkflows} from './util'

export interface Props {
  taskId: DataObjectId
}

export const WorkflowInTask = (props: Props) => {
  useSyncEventUpdateEffect('current', {
    filter: [props.taskId, globals.getCompanyId()],
    deps: [props.taskId]
  })

  const workflows = getWorkflows(props.taskId)
  const workflowState = getTaskWorkflowState(props.taskId)
  if (!workflows.length) {
    return null
  }

  return (
    <div className="mb-24">
      <div className="text-third-old text-12">
        {Lang.msg.workflow.workflowsInBoard}
      </div>
      {workflowState ? (
        <InWorkflow {...{workflowState, workflows, ...props}} />
      ) : (
        <NotInWorkflow {...{workflows, ...props}} />
      )}
    </div>
  )
}
